import React from "react";
import { Card, Button, Stack, Text } from "@shopify/polaris";
import { useTranslation } from "react-i18next";

export default function SecondaryPlanCard({ plan, loading, activatePlan }) {
  const { t } = useTranslation();
  const { name, type, price, description, current, available } = plan;
  return (
    <Card sectioned>
      <Stack alignment="center" spacing="extraLoose">
        <Stack.Item fill>
          <Stack vertical spacing="extraTight">
            <Text variant="headingMd" as="h2">{name}</Text>
            <p
              dangerouslySetInnerHTML={{
                __html: description,
              }}
            ></p>
          </Stack>
        </Stack.Item>
        <Stack spacing="tight" alignment="trailing">
          <Text  variant="bodyMd" as="span" color="success">
            <Text variant="heading4xl" as="p">${price}</Text>
          </Text>
          <Text variant="bodyMd" as="span">{t("settings.plan.usdPerMonth")}</Text>
        </Stack>
        <Button
          fullWidth
          size="large"
          disabled={!available || current}
          onClick={() => activatePlan(type)}
          loading={loading}
        >
          {current ? t("settings.plan.planCard.currentPlan") : t("settings.plan.planCard.chooseThisPlan")}
        </Button>
      </Stack>
    </Card>
  );
}
